import { render } from "./WizardContainer.vue?vue&type=template&id=4d645e4f&ts=true"
import script from "./WizardContainer.vue?vue&type=script&lang=ts"
export * from "./WizardContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/admissibles-front/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__